import Bridge1Offline from "@material-ui/icons/GridOffOutlined";
import Bridge1Online from "@material-ui/icons/GridOnOutlined";
import Driver2Offline from "@material-ui/icons/BlurOffOutlined";
import Driver2Online from "@material-ui/icons/BlurOnOutlined";
import SirenOffByQRCode from "@material-ui/icons/VolumeOffOutlined";
import NoACPower from "@material-ui/icons/PowerOffOutlined";
import ACPowerRestored from "@material-ui/icons/PowerOutlined";
import DeadBattery from "@material-ui/icons/BatteryAlertOutlined";
import BatteryDisconnected from "@material-ui/icons/BatteryUnknownOutlined";
import BatteryFullyCharged from "@material-ui/icons/BatteryFullOutlined";
import ChangeOfInternetAccessConfiguration from "@material-ui/icons/SettingsRemoteOutlined";
import SirenTrigger from "@material-ui/icons/NotificationsActiveOutlined";
import SirenDisconnected from "@material-ui/icons/NotificationsOffOutlined";
import SirenConnected from "@material-ui/icons/NotificationsNoneOutlined";
import PackageDelivery from "@material-ui/icons/MarkunreadMailboxOutlined";
import OrderPickupByPassword from "@material-ui/icons/VpnKeyOutlined";
import Accessible from "@material-ui/icons/AccessibleRounded";

export type IconTypes =
  | "bridge1offline"
  | "bridge1online"
  | "driver2offline"
  | "driver2online"
  | "qrcoderead"
  | "invalidqrcode"
  | "sirenoffbyqrcode"
  | "noacpower"
  | "acpowerrestored"
  | "batterydisconnected"
  | "deadbattery"
  | "batteryfullycharged"
  | "changeofinternetaccessconfiguration"
  | "sirentrigger"
  | "sirenturnedoffbyremotecommand"
  | "sirendisconnected"
  | "sirenreconnected"
  | "openbox"
  | "closedbox"
  | "packagedelivery"
  | "orderpickupbypassword"
  | "qrcodepickup"
  | "opendoorafterdelivery"
  | "opendoorafterwithdrawal"
  | "failuretoopenthedoorondelivery"
  | "failuretoopenthedooronwithdrawal"
  | "dooropeningtestfailed"
  | "accessible";

type IconByName = {
  [key in IconTypes]: JSX.Element;
};
const eventIcons: IconByName = {
  bridge1offline: <Bridge1Offline fontSize="large" style={{ color: "red" }} />,
  bridge1online: <Bridge1Online fontSize="large" style={{ color: "green" }} />,
  driver2offline: <Driver2Offline fontSize="large" />,
  driver2online: <Driver2Online fontSize="large" />,
  qrcoderead: <Bridge1Online fontSize="large" />, //TODO
  invalidqrcode: <Bridge1Online fontSize="large" />, //TODO
  sirenoffbyqrcode: <SirenOffByQRCode fontSize="large" />,
  noacpower: <NoACPower fontSize="large" />,
  acpowerrestored: <ACPowerRestored fontSize="large" />,
  batterydisconnected: (
    <BatteryDisconnected fontSize="large" style={{ color: "red" }} />
  ),
  deadbattery: <DeadBattery fontSize="large" />,
  batteryfullycharged: <BatteryFullyCharged fontSize="large" />,
  changeofinternetaccessconfiguration: (
    <ChangeOfInternetAccessConfiguration fontSize="large" />
  ),
  sirentrigger: <SirenTrigger fontSize="large" style={{ color: "orange" }} />,
  sirenturnedoffbyremotecommand: (
    <SirenDisconnected fontSize="large" style={{ color: "var(--grayLv1)" }} />
  ),
  sirendisconnected: (
    <SirenDisconnected fontSize="large" style={{ color: "red" }} />
  ),
  sirenreconnected: (
    <SirenConnected fontSize="large" style={{ color: "green" }} />
  ),
  openbox: <Bridge1Online fontSize="large" />, //TODO
  closedbox: <Bridge1Online fontSize="large" />, //TODO
  packagedelivery: <PackageDelivery fontSize="large" />,
  orderpickupbypassword: <OrderPickupByPassword fontSize="large" />,
  qrcodepickup: <Bridge1Online fontSize="large" />, //TODO
  opendoorafterdelivery: <Bridge1Online fontSize="large" />, //TODO
  opendoorafterwithdrawal: <Bridge1Online fontSize="large" />, //TODO
  failuretoopenthedoorondelivery: <Bridge1Online fontSize="large" />, //TODO
  failuretoopenthedooronwithdrawal: <Bridge1Online fontSize="large" />, //TODO
  dooropeningtestfailed: <Bridge1Online fontSize="large" />, //TODO
  accessible: <Accessible fontSize="large" />,
};

interface EventIconsProps {
  name: IconTypes;
}
export default function EasyTechIcons({ name }: EventIconsProps) {
  return eventIcons[name];
}
